var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServidorInfoDisplay',{attrs:{"espaco_total":_vm.metricas.espaco_total,"espaco_livre":_vm.metricas.espaco_livre,"espaco_usado":_vm.metricas.espaco_usado,"percentual_uso":_vm.metricas.percentual_uso}})
}
var staticRenderFns = []

export { render, staticRenderFns }